/* eslint-disable max-len */
import React, { Component } from 'react';
import Button from 'antd/es/button/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Checkbox from 'antd/es/checkbox';
import Text from 'antd/es/typography/Text';
import Card from 'antd/es/card';
import Flex from 'antd/es/flex';
import Divider from 'antd/es/divider';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { IRegisterForm } from '../store';
import routesConfig from '../../../config/routes';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const usernameRegex = /^[A-Za-z0-9_-]{5,20}$/;

class Registration extends Component<IRootStoreProps> {
  state = { userName: '' };

  componentDidMount(): void {
    const queryParams = new URLSearchParams(window.location.search);
    const refLogin = queryParams.get('ref');

    if (refLogin && !this.props.store.auth.referrerLogin) {
      this.props.store.auth.setReferrer(refLogin);
    }
  }

  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  render() {
    const { store } = this.props;

    return (
      <Card title="Регистрация" style={{ width: '100%' }}>
        <Text>{'Для регистрации введите Ваш email и пароль.'}</Text>
        {store.auth.referrerLogin && <Text>{` Вас пригласил: ${store.auth.referrerLogin}`}</Text>}
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          style={{ marginTop: 20 }}
          initialValues={{ remember: false }}
          onFinish={store.auth.register}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item<IRegisterForm>
            name="login"
            label="Login"
            rules={[
              {
                required: true,
                message: 'Введите логин',
              },
              {
                pattern: usernameRegex,
                message: 'Логин должен содержать от 5 до 20 символов: латиница, цифры, - и _',
              },
              {
                validator: async (_, value) => {
                  if (!value || !usernameRegex.test(value) || value === this.state.userName) {
                    return Promise.resolve();
                  }
                  store.auth.checkLogin(value);
                  this.setState({ userName: value });

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Flex>
              <Input disabled={store.loading} />
              {store.auth.loginIsValid && (
                <CheckCircleOutlined style={{ marginLeft: 10, fontSize: 20, color: 'green' }} />
              )}
              {store.requestError && <CloseCircleOutlined style={{ marginLeft: 10, fontSize: 20, color: 'red' }} />}
            </Flex>
          </Form.Item>

          <Form.Item<IRegisterForm>
            name="email"
            label="Email"
            rules={[
              { type: 'email', message: 'Этот Email не валидный!' },
              { required: true, message: 'Пожалуйста введите Email!' },
            ]}
            validateTrigger="onSubmit"
          >
            <Input />
          </Form.Item>
          <Form.Item<IRegisterForm>
            label="Пароль"
            name="password"
            rules={[
              { required: true, message: 'Пожалуйста введите ваш пароль!' },
              {
                min: 8,
                max: 30,
                pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/,
                message:
                  'Пароль должен быть от 8 до 30 символов и содержать как минимум одну цифру, одну латинскую строчную и заглавную букву.',
              },
            ]}
            validateTrigger="onSubmit"
          >
            <Input.Password />
          </Form.Item>
          <Form.Item<IRegisterForm>
            label="Повторите пароль"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: 'Пожалуйста введите ваш пароль еще раз!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('Пароли должны совпадать!'));
                },
              }),
            ]}
            validateTrigger="onSubmit"
          >
            <Input.Password />
          </Form.Item>
          <Form.Item<IRegisterForm>
            name="remember"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Пожалуйста подтвердите согласие')),
              },
            ]}
          >
            <Checkbox defaultChecked={false}>
              {
                'Регистрируясь, вы подтверждаете, что прочитали, поняли и признали нашу Политику конфиденциальности, а также принимаете наши Правила.'
              }
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: 20 }} loading={store.loading}>
              {'Зарегистрировать'}
            </Button>
          </Form.Item>
          {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
        </Form>
        <Flex justify="center" align="center">
          <Link to={routesConfig.forgotPassword}>
            <Button type="text">Забыли пароль?</Button>
          </Link>
          <Divider type={'vertical'} />
          <Link to={routesConfig.login}>
            <Button type="text">Войти</Button>
          </Link>
        </Flex>
      </Card>
    );
  }
}

export const RegistrationPage: WithoutStore = withStore(observer(Registration));
